var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",style:({width: '100%', 'height': _vm.height})})
}
var staticRenderFns = []

export { render, staticRenderFns }